import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Grid, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import useStyles from '../useStyles';
import { iRootState } from '../redux/store';
import { PaymentTermStatus } from '../redux/models/paymentTerms';
import { TermProps } from '../PaymentTerms/Installment';

const TermsStatus = function TermsStatus(): React.ReactElement {
  const classes = useStyles();

  const termsCount = useSelector((state: iRootState) => {
    const allUniqueTerms = Array.from(
      new Set(state.paymentTerms.terms.map((item: TermProps) => item.termOrder))
    );

    return allUniqueTerms.length;
  });

  const terms = useSelector((state: iRootState) =>
    state.paymentTerms.terms.filter(
      t =>
        t.paymentStatus === PaymentTermStatus.Paid ||
        t.paymentStatus === PaymentTermStatus.Pending ||
        t.paymentStatus === PaymentTermStatus.UnderReview
    )
  );

  const { termOrder, sellPrice, changedAtUTC } = terms
    // eslint-disable-next-line func-names
    .sort(function(a, b) {
      if (a.changedAtUTC && b.changedAtUTC) {
        // eslint-disable-next-line no-nested-ternary
        return a.changedAtUTC > b.changedAtUTC
          ? 1
          : a.changedAtUTC < b.changedAtUTC
          ? -1
          : 0;
      }
      return 0;
    })
    .reverse()[0];

  const remainingBalance = useSelector(
    (state: iRootState) => state.paymentTerms.remainingTotal
  );

  const getTermDescriptionId = function getTermDescriptionId(
    termOrderId: number
  ): string {
    switch (termOrderId) {
      case 0:
        return 'firstPaymentDesc';
      case 1:
        return 'secondPaymentDesc';
      case 2:
        return 'thirdPaymentDesc';
      case 3:
        return 'fourthPaymentDesc';
      default:
        return 'firstPaymentDesc';
    }
  };

  const getTermDescriptionMessage = function getTermDescriptionMessage(
    termOrderId: number
  ): string {
    switch (termOrderId) {
      case 0:
        return 'First Payment';
      case 1:
        return 'Second Payment';
      case 2:
        return 'Third Payment';
      case 3:
        return 'Fourth Payment';
      default:
        return 'First Payment';
    }
  };

  return (
    <Grid item>
      <Typography className={classes.statusStyle}>
        <FormattedMessage
          id={getTermDescriptionId(termOrder)}
          defaultMessage={getTermDescriptionMessage(termOrder)}
        />
        <FormattedMessage
          id='paidfromTotal'
          defaultMessage=' ( {paidCount} of {termsCount} )'
          values={{
            paidCount: terms.length,
            termsCount
          }}
        />
        <FormattedMessage
          id='lastTermPaidOn'
          defaultMessage=' in the amount of {sellPrice, number, ::sign currency/USD} made on '
          values={{
            sellPrice
          }}
        />
        <FormattedDate
          value={changedAtUTC}
          month='numeric'
          day='numeric'
          year='numeric'
          hour12
          hour='numeric'
          minute='numeric'
          second='numeric'
          timeZoneName='short'
        />
        <FormattedMessage
          id='remainingBalanceMsg'
          defaultMessage=' ( Remaining Balance {remainingBalance, number, ::sign currency/USD} )'
          values={{ remainingBalance }}
        />
      </Typography>
    </Grid>
  );
};

export default TermsStatus;
